import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useGetSupportTickets(data = {}) {
  const { enabled = false, config = {}, queryKey = ['support-tickets'] } = data;
  const { params = {} } = config;
  const { privateFetch } = useContext(FetchContext);

  const getCategory = () => privateFetch.get('/v1/admin/ticket/support/list', { params });

  return useQuery(queryKey, getCategory, {
    enabled,
    keepPreviousData: true,
  });
}

export default useGetSupportTickets;
